<template>
  <div class="box-login">
    <Navbar />
    <form @submit="login">
      <div class="login">
        <b-container class="text-left" style="margin: auto;">
          <b-row class="justify-content-center">
            <b-col style="background: black;" lg="5" md="7" sm="10" cols="10">
              <h4 style="color:#fff" class="text">เข้าสู่ระบบ</h4>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col class="one" lg="5" md="7" sm="10" cols="10">
              <p></p>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col class="two" lg="5" md="7" sm="10" cols="10">
              <b-row>
                <b-col>
                  <div class="form-group">
                    <label for="exampleInputEmail1">
                      ชื่อผู้ใช้
                      <span class="required">*</span>
                    </label>
                    <input id="input1" v-model="userdadta.username" required class="form-control" />
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="form-group">
                    <label>
                      รหัสผ่าน
                      <span class="required">*</span>
                    </label>
                    <input
                      id="input2"
                      v-model="userdadta.password"
                      required
                      type="password"
                      class="form-control"
                    />
                  </div>
                </b-col>
              </b-row>
              <b-row class="text-center">
                <b-col>
                  <button type="submit" class="btn btn-success btn-sm btnLogin">เข้าสู่ระบบ</button>
                </b-col>
              </b-row>
              <br />
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col class="one" lg="5" md="7" sm="10" cols="10">
              <h4 class="text"></h4>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </form>
    <Footer />
    <b-modal
      ref="content-ads"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      data-backdrop="false"
    >
      <b-container class="text-center">
        <b-row class="mb-2">
          <b-col>
            <b>กำลังเข้าสู่ระบบ กรุณารอสักครู่...</b>
            <b-spinner class="ml-3" variant="primary" label="Spinning"></b-spinner>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <b-carousel
              controls
              id="carousel-1"
              v-model="slide"
              :interval="2500"
              background="#ababab"
              img-width="1024"
              img-height="480"
              style="text-shadow: 1px 1px 2px #333;"
            >
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide1.png"
              ></b-carousel-slide>
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide2.png"
              ></b-carousel-slide>
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide3.jpg"
              ></b-carousel-slide>
              <b-carousel-slide
                caption
                text
                img-src="https://www.kmppartners.info/ebidding/img/Slide4.jpg"
              ></b-carousel-slide>
            </b-carousel>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal ref="change-password" centered hide-footer title="คำเตือน" size="sm">
      <b-container>
        <b-row class="mt-3">
          <b-col>
            ตอนนี้ชื่อผู้ใช้เเละรหัสผ่านของคุณเป็นชื่อเดียวกันอยู่
            <span
              class="required"
            >กรุณาเปลี่ยนรหัสผ่านเพื่อความปลอดภัย</span>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="4">
            รหัสผ่านใหม่
            <span class="required">&nbsp;*</span>
          </b-col>
          <b-col>
            <b-form-input type="password" ref="p1" size="sm" v-model="changeP.password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="4">
            ยืนยันรหัสผ่านใหม่
            <span class="required">&nbsp;*</span>
          </b-col>
          <b-col>
            <b-form-input type="password" ref="p2" size="sm" v-model="changeP.password2"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-4 text-center">
          <b-col>
            <b-button size="sm" variant="success" @click="change">เปลี่ยนรหัสผ่าน</b-button>
            <span class="m-2"></span>
            <b-button size="sm" variant="danger" @click="close">ยกเลิก</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
export default {
  components: { Navbar, Footer },
  mounted() {
    axios.get("http://www.geoplugin.net/json.gp").then(res => {
      this.access_ipaddress = res.data.geoplugin_request;
    });
  },
  data() {
    return {
      changeP: {
        password: null,
        password2: null,
        username: null
      },
      first: false,
      slide: 0,
      userdadta: {
        username: "",
        password: ""
      },
      access_ipaddress: null
    };
  },
  methods: {
    close: function() {
      this.changeP.password = null;
      this.changeP.password2 = null;
      this.$refs["change-password"].hide();
      this.$router.push("/Overview");
    },
    hideAds: function() {
      this.$refs["content-ads"].hide();
      this.$router.push("/Overview");
    },
    change: function() {
      if (this.changeP.password === null || this.changeP.password === "") {
        this.$bvToast.toast("กรุณากรอกรหัสผ่าน", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["p1"].focus();
      } else if (
        this.changeP.password2 === null ||
        this.changeP.password2 === ""
      ) {
        this.$bvToast.toast("กรุณายืนยันรหัสผ่าน", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["p2"].focus();
      } else if (this.changeP.password2 !== this.changeP.password) {
        this.$bvToast.toast("รหัสผ่านไม่ตรงกัน", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["p2"].focus();
      } else {
        this.changeP.username = this.$session.get("username");
        axios
          .post(
            "https://www.kmppartners.info:1009/api/ebidding/change/pass/customer",
            this.changeP
          )
          .then(res => {
            if (res.data.status) {
              this.$bvModal
                .msgBoxOk("กรุณาเข้าสู่ระบบไหมอีกครั้งด้วยรหัสผ่านใหม่", {
                  title: "สำเร็จ",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                  okTitle: "ตกลง"
                })
                .then(value => {
                  if (value) {
                    location.reload();
                  }
                });
            } else {
              this.$bvModal.msgBoxOk(res.data.error, {
                title: "ผิดพลาด",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
                okTitle: "ตกลง"
              });
            }
          });
      }
    },
    login: function(e) {
      this.status = false;
      e.preventDefault();
      axios
        .post("https://www.kmppartners.info:1009/api/ebidding/login", this.userdadta)
        .then(res => {
          if (res.data.statusLogin) {
            axios
              .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                access_username: res.data.response.username,
                access_module: "เข้าสู่ระบบ E-Bidding",
                access_ipaddress: this.access_ipaddress
              })
              .then(rest => {
                if (rest.data.statusLog) {
                  this.$session.start();
                  if (res.data.first) {
                    this.first = true;
                  } else {
                    this.first = false;
                  }
                  this.$session.set("username", res.data.response.username);
                  this.$session.set("fullname", res.data.response.fullname);
                  this.$session.set("role", res.data.response.role);
                  if (this.$session.get("role") === "Customer") {
                    axios
                      .post("https://www.kmppartners.info:1009/api/ebidding/notify", {
                        customer: this.$session.get("fullname")
                      })
                      .then(rests => {
                        if (rests.data.status) {
                          if (this.$session.get("role") === "Customer") {
                            if (res.data.first) {
                              this.$refs["change-password"].show();
                            } else {
                              this.$refs["content-ads"].show();
                              setTimeout(this.hideAds, 10000);
                            }
                          } else {
                            this.$router.push("/Overview");
                          }
                        }
                      });
                  } else {
                    this.$router.push("/Overview");
                  }
                } else {
                  this.$bvToast.toast(rest.data.error, {
                    title: "ผิดพลาด",
                    autoHideDelay: 5000,
                    appendToast: true,
                    variant: "danger"
                  });
                }
              });
          } else {
            if (res.data.error === "หมดอายุ") {
              this.$bvModal.msgBoxOk(
                "บัญชีผู้ใช้ของคุณหมดเอายุการใช้งานเเล้ว กรุณาติดต่อเราผ่าน Line Official",
                {
                  title: "ผิดพลาด",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "danger",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                  okTitle: "ตกลง"
                }
              );
            } else {
              this.$bvModal.msgBoxOk(res.data.error, {
                title: "ผิดพลาด",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
                okTitle: "ตกลง"
              });
            }
          }
        });
    }
  }
};
</script>

<style>
.required {
  color: red !important;
}
.box-login {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.login {
  font-family: "K2D";
  margin: 5% !important;
  padding-bottom: 12%;
}
@media (max-width: 600px) {
  .login {
    padding-bottom: 300px;
  }
}
.one {
  background-color: #005a7c;
}
.text {
  padding: 10px;
  color: rgb(0, 0, 0);
}
.two {
  padding: 10px;
  background-color: white;
}
.form-group {
  padding: 5px;
  margin-bottom: 5px !important;
}
</style>
